import React, { Component } from 'react';

import {Link} from 'react-router';
import {observer} from 'mobx-react';


class HomePage extends Component {
  render () {
    const photo = this.props.photos[Math.floor(Math.random() * this.props.photos.length)];
//$this->pageTitle= "Turner Roofing York - Expert Roofers Specialising in Slating & Tiling";
//$this->layout = "column2";
    return (
      <div>
        <div className="grid_16">
        <br />
        <h1>Slating &amp; Tiling Specialists based in York</h1>
        <p>With over 50 years combined experience we professionally undertake all aspects of roofing, from minor repairs to full roof relacement and installation, using both new products and reclaimed materials. All our work is finished to the highest possible standard.</p>
        <br />
        </div>
        <div className="grid_8">
        <h2>Our Services</h2>
        <p>We offer a full range of roofing services, including:</p>
        <br />
        <ul className="ticklist">
          <li>All aspects of roofing work, including slating, tiling and pointing</li>
          <li>Velux window installation</li>
          <li>Slate and Tile repairs</li>
          <li>Guttering and facias fitted</li>
          <li>Insulation services</li>
          <li>Leadwork &amp; Lead Roofing</li>
          <li>All aspects of pointing</li>
          <li>Ridge tiling and rebedding chimney pots</li>
        </ul>
        </div>
        <div className="grid_8">
          <Link to="/photos">
            <img src={photo.imageUrl} title={photo.title} className="thumbnail" style={{width: '95%'}} alt={photo.title} />
          </Link>
        </div>
        <div className="grid_16">
        <div className="infobox">
          <h2>
            <Link to="/contact">Contact us for a free, no obligation estimate</Link>
          </h2>
          <p>Need an urgent roof repair? Or maybe just some friendly roofing advice? we're happy to help.</p>
          <br />
          <p className="big">
            <Link to="/contact">Send us an email</Link>
            {' '}
            or call: <span className="phone">07866 432026</span> (Mobile), <span className="phone">01904 793538</span> (Home)<br />
          </p>
        </div>
        </div>
      </div>
    );
  }
}

export default observer(['photos'])(HomePage);


/** WEBPACK FOOTER **
 ** ./src/HomePage.js
 **/